export const selectFunderProfileInfo = ({ profile }) => profile
export const selectFunderPrecalculatedInfo = ({ profile }) => profile.precalculated

export const selectIsFunderProfileDissolved = ({ profile: { status } }) => status === 'dissolved'
export const selectIsFunderProfileLoading = ({ profile: { isLoading } }) => isLoading

const addFacetType = (facets = [], facetType, isFilter = true) =>
  facets.map(facet => ({ ...facet, facetType, isFilter }))
export const selectFunderPills = ({
  profile: {
    funderCauses = [],
    funderPopulations = [],
    funderRegions = [],
    funderInternationals = [],
    funderActivityOption = []
  }
}) => [
  ...addFacetType(funderCauses, 'causes'),
  ...addFacetType(funderPopulations, 'populations'),
  ...addFacetType(funderRegions, 'regions'),
  ...addFacetType(funderInternationals, 'internationals'),
  ...addFacetType(funderActivityOption, 'activityOption', false)
]

export const selectFunderProfileCategory = ({ profile: { primaryCategory } }) =>
  primaryCategory
    ? primaryCategory.root && primaryCategory.root.id !== primaryCategory.id
      ? `${primaryCategory.name}/${primaryCategory.root.name}`
      : primaryCategory.name
    : null
